import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

import { AppFeatureExtensions } from '@app/app-feature-extensions.config';
import { TeamRole, User } from '@shared/models';
import { AtsProviders } from '@shared/models/AtsMessage';
import { TeamMembersListItem } from '@shared/models/team-members-list-item.model';
import { UserTemplateTypes } from '@shared/user-item/user-item.component';
import { Store } from '@ngrx/store';
import { SharedResourcesType } from '@core/shared-resources/shared-resources.model';
import { convertTeamMemberListItemsToTeamMemberArray } from '@modules/jobs-page/utils/utils';
import { sharedResourcesStoreCurrent } from '@core/shared-resources/store/shared-resources.actions';

@Component({
  selector: 'mojo-team-members-card',
  templateUrl: 'team-members-card.component.html',
  styleUrls: ['team-members-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeamMembersCardComponent implements OnChanges {
  @Output() refresh: EventEmitter<{}> = new EventEmitter();
  @Input() teamMembersList: TeamMembersListItem[];
  @Input() isJobLoading = false;
  @Input() editPrivilege;
  @Input() viewPrivilege;
  @Input() isTalentPoolConfig = false;
  @Input() isExpandible = true;
  @Input() sharedResource?: { resourceId: number; resourceType: SharedResourcesType };

  oracleRefreshJob = AppFeatureExtensions.ORACLE_REFRESH_JOB;

  teamMembers: User[];
  userTemplateTypes = UserTemplateTypes;
  loading = true;
  isPanelOpen = true;

  constructor(private store: Store) {}

  ngOnChanges({ teamMembersList }: SimpleChanges) {
    const members = !!teamMembersList ? teamMembersList.currentValue : [];
    this.loading = this.checkIfAllUsersAreLoaded(members) || this.isJobLoading;
  }

  private checkIfAllUsersAreLoaded(teamMembersList: TeamMembersListItem[]): boolean {
    return teamMembersList.some((teamMemberItem) => !teamMemberItem.user);
  }

  onEdit(event) {
    event.stopPropagation();
    if (this.sharedResource) {
      const teamMembers = convertTeamMemberListItemsToTeamMemberArray(this.teamMembersList).map(
        (teamMember) => {
          teamMember.role = TeamRole.regularRecruiter;
          return teamMember;
        },
      );
      this.store.dispatch(
        sharedResourcesStoreCurrent({
          resourceId: this.sharedResource.resourceId,
          resourceType: this.sharedResource.resourceType,
          teamMembers,
        }),
      );
    }
  }

  refreshJob() {
    this.refresh.emit({ provider: AtsProviders.HCM });
  }
}
